module.exports = __webpack_public_path__ + "media/images/gallery/stars_off-d8d357e369adc14200829e80573add4a.gif";